import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './styles/index.css';

// Import from centralized Firebase config
import './firebase/config';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* react-helmet-async (not the unmaintained react-helmet, which trips
        React 18's UNSAFE_componentWillMount warnings). Every <SEO> on the page
        writes into this provider. */}
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Registers the PWA service worker (src/service-worker.js) built by
// react-scripts/Workbox. A waiting update dispatches a window event that
// UpdateAvailableBanner listens for, instead of silently taking over.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    window.dispatchEvent(new CustomEvent('sw-update-available', { detail: registration }));
  },
});